import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'businessCard',
  type: 'node--business_card',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    annualReturn: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'annual_return',
    },
    appraisalAddress: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'appraisal_address',
    },
    appraisalComment: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'appraisal_comment',
    },
    buildedSurface: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'builded_surface',
    },
    deadline: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'deadline',
    },
    investment: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'investment',
    },
    investmentForm: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'investment_form',
    },
    marketUrls: {
      type: 'string',
      required: false,
      isArray: true,
      name: 'market_urls',
    },
    marketValue: {
      type: 'float',
      required: false,
      isArray: true,
      name: 'market_value',
    },
    nexumValue: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'nexum_value',
    },
    publicada: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'publicada',
    },
    purpose: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'purpose',
    },
    reportDate: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'report_date',
    },
    titleApp: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'title_app',
    },
  },
  relationships: {
    images: {
      type: 'file--file',
      required: false,
      isArray: true,
      name: 'images',
    },
  },
};
export const BusinessService = createService(base, configuration, API_CONFIG.API);
export const BusinessCardModule = createModule(BusinessService, true);



// WEBPACK FOOTER //
// ./src/models/businessCard.js